import { useLiveData, useService } from '@toeverything/infra';

import { InstanceBrand } from '@affine/core/components/instance-branding';
import { AppSidebarService } from '../../services/app-sidebar';
import { navHeaderContentStyle, navHeaderStyle } from '../index.css';
import { SidebarSwitch } from './sidebar-switch';

export const SidebarHeader = () => {
  const appSidebarService = useService(AppSidebarService).sidebar;
  const open = useLiveData(appSidebarService.open$);

  return (
    <div className={navHeaderStyle} data-open={open}>
      <div className={navHeaderContentStyle}>
        <SidebarSwitch show={open} />
        {open ? <InstanceBrand /> : null}
      </div>
    </div>
  );
};

export * from './sidebar-switch';
